import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange} from '@angular/core';
import * as _ from 'lodash';
import {ActivatedRoute} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {PlayerService} from '../../player';
import {MdDialog, MdDialogRef} from '@angular/material';
import {SongDetailComponent} from '../../songs/song-detail/song-detail.component';
@Component({
    selector: 'data-tables',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.css']
})
export class DataTableComponent implements OnInit,OnChanges {
    @Input() columns:Array<any> = new Array<any>();
    @Input() data:Array<any> = new Array<any>();
    @Input() showSongActions:boolean = true;
    @Output() sortBy:EventEmitter<any> = new EventEmitter();
    @Output() refresh:EventEmitter<any> = new EventEmitter();
    dialogRef:MdDialogRef<SongDetailComponent>;
    private header:Array<any> = new Array<any>();
    title:any = "";
    type:any = "";
    type2:any = "";
    radioId:any = "";
    column1 = new Column();
    @BlockUI() blockUI:NgBlockUI;
    private playerEventSubscriber = null;
    itsId:any = '';
    playingId:number = 0;
    checkIfPlaylist: any = true;

    constructor(private route:ActivatedRoute, private playerService:PlayerService, public dialog:MdDialog) {
    }

    mouseHovering(index) {
        this.data[index].isHovering = true;
    }

    mouseLeaving(index) {
        this.data[index].isHovering = false;
    }

    toggleControls(index) {
        this.data[index].isHovering = !this.data[index].isHovering;
    }
    
    ngOnChanges(changes:{ [propKey: string]: SimpleChange }) {
        this.playerService.playerEvent.subscribe((event) => {
            if (event.type === 'track:id') {
                this.playingId = this.playerService.playingId;

                let index = _.findIndex(this.data, {
                    id: this.playingId
                });
                if (this.data[index]) {
                    this.data[index].isHovering = false;
                }
            }
        });
    }

    ngOnInit() {
        this.checkIfPlaylist =  false;
        this.playingId = this.playerService.playingId;
        if (this.route.snapshot.data['id']) {
            this.itsId = this.route.snapshot.data['id'];
        }
        if (this.columns.length > 0) {
            if(screen.width < 361) {
                for(let i=0; i< this.columns.length; i++){
                    if(this.columns[i].title == "Artist" || this.columns[i].title == "Name"){
                        this.columns[i].width = "120px";
                    }
                }
            }
            this.columns.forEach((arrayItem) => {
                let column = new Column();
                column.title = (arrayItem.type === 'text' || arrayItem.type === 'anchor' || arrayItem.type === 'date' || arrayItem.type === 'fix') ? arrayItem.title.toUpperCase() : arrayItem.title;
                column.key = arrayItem.key;
                column.type = arrayItem.type;
                column.width = arrayItem.width;
                column.responsiveIndex = arrayItem.responsiveIndex;
                if (typeof arrayItem.isSortable !== undefined && arrayItem.isSortable === false) {
                    column.isSortable = arrayItem.isSortable;
                }
                if (typeof arrayItem.fixValue !== undefined) {
                    column.fixValue = arrayItem.fixValue;
                }
                column.textStyle = arrayItem.textStyle;
                if (arrayItem.type === 'anchor') {
                    this.column1 = arrayItem;
                }
                this.header.push(column);
            });
        }

        if (this.route.snapshot.data['title']) {
            if (this.route.snapshot.data['title'].toUpperCase() == "RADIO" || this.route.snapshot.data['title'].toUpperCase() == "MY RADIO") {
                this.type = "R";
            } else if (this.route.snapshot.data['title'].toUpperCase() == "DISCOVER NEW MUSIC" || this.route.snapshot.data['title'].toUpperCase() == "MUSIC FOR MOVIES" || this.route.snapshot.data['title'].toUpperCase() == "ACTIVITY PLAYLISTS" || this.route.snapshot.data['title'].toUpperCase() == "FANS PLAYLISTS" || this.route.snapshot.data['title'].toUpperCase() == "BUSINESS PLAYLISTS" || this.route.snapshot.data['title'].toUpperCase() == "GENRES PLAYLISTS" || this.route.snapshot.data['title'].toUpperCase() == "MY PLAYLISTS" || this.route.snapshot.data['title'].toUpperCase() == "RECENT LICENSES") {
                this.type = "P";
            } else if (this.route.snapshot.data['title'].toUpperCase() == "WEGET OFFICIAL") {
                this.type = "OP";
            } else if (this.route.snapshot.data['title'].toUpperCase() == "PRODUCTION CREDITS SEARCH" || this.route.snapshot.data['title'].toUpperCase() == "MOST PLAYED" || this.route.snapshot.data['title'].toUpperCase() == "MOST DOWNLOADED" || this.route.snapshot.data['title'].toUpperCase() == "NEWEST MUSIC" || this.route.snapshot.data['title'].toUpperCase() == "SONGS") {
                this.type = "C";
                this.checkIfPlaylist =  false;
                if (this.route.snapshot.data['title'].toUpperCase() == "SONGS" && this.route.snapshot.data['type'].toUpperCase() != "CS") {
                    this.type2 = "Search";
                    this.checkIfPlaylist =  null;
                    if(document.getElementById("backLink")){
                    this.checkIfPlaylist =  true;
                    }
                } else {
                    this.type2 = "";
                }
            }
        }
        this.playerEventSubscriber = this.playerService.playerEvent.subscribe((event) => {
            if (typeof event.data === "object" && event.data != null) {
                if (event.data.length > 0) {
                    if (event.data[0].type == 'R') {
                        this.radioId = event.data[0].id;
                    }
                }
            }
        });
    }

    getColumnValueForRow(row, col:Column) {
        if (col.key.split('.').length > 1) {
            return this.getNestedObjectIndexes(row, col);
        } else {
            if (row[col.key]) {
                return row[col.key];
            }
        }
        return '';
    }

    getNestedObjectIndexes(row, col:Column) {
        let a = col.key.split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
            let k = a[i];
            if (row[k]) {
                row = row[k];
            } else {
                return '';
            }
        }
        return row;
    }

    getAnchorUrl(row, col) {
        let urlHelper = (item, url) => {
            if (!item || !item._type) {
                return '';
            }
            if (col.key == "artist.name") {
                url.push('/artist');
                url.push(row.artist.slug);
                return url;
            }
            if (item._type === 'artist') {
                url.push('/artist');
            }
            if (item._type === 'song') {
                url.push('/song');
            }
            if (item._type === 'playlist') {
                url.push('/playlist');
            }
            url.push(item.slug);
            return url;
        };
        let url = [];
        if (col.key.split('.').length > 1) {
            let item = row[col.key.split('.')[0]];
            urlHelper(item, url);
        } else {
            urlHelper(row, url);
        }
        return url;
    }

    openSongDetail(song) {
        this.blockUI.start('Loading, please wait...');
        var width = '', height = '';
        var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
        width = '37%';
        setTimeout(() => {
            this.dialogRef = this.dialog.open(SongDetailComponent, {
                width: width
            });
            if((song.credits && song.credits.length != 0) || (song.publishers && song.publishers.length != 0) || (song.writers && song.writers.length != 0)) { 
                this.dialogRef.componentInstance.song = song;
            } else {
                this.dialogRef.componentInstance.slug = song.slug;
            }
            return false;
        }, 1000);
    }

    sort(column: any, index) {
        if(column.isSortable === false) {
            return;
        }
        // toggle sort order for this column
        if(column.title != "") {
            if(column.sortOrder === SORTORDER.UNSORTED) {
                column.sortOrder = SORTORDER.SORT_ASC;
            } else if (column.sortOrder === SORTORDER.SORT_ASC) {
                column.sortOrder = SORTORDER.SORT_DESC;
            } else if (column.sortOrder === SORTORDER.SORT_DESC) {
                column.sortOrder = SORTORDER.UNSORTED;
            }
            // reset sort order for others
            this.header.forEach((arrayItem:Column) => {
                if (arrayItem.key !== column.key) {
                    arrayItem.sortOrder = SORTORDER.UNSORTED;
                }
            });
        } else {
            if (this.column1.sortOrder === SORTORDER.UNSORTED) {
                this.column1.sortOrder = SORTORDER.SORT_ASC;
            } else if (this.column1.sortOrder === SORTORDER.SORT_ASC) {
                this.column1.sortOrder = SORTORDER.SORT_DESC;
            } else if (this.column1.sortOrder === SORTORDER.SORT_DESC) {
                this.column1.sortOrder = SORTORDER.UNSORTED;
            }
            // reset sort order for others
            this.header.forEach((arrayItem:Column) => {
                if (arrayItem.key !== this.column1.key) {
                    arrayItem.sortOrder = SORTORDER.UNSORTED;
                }
            });
        }
        if (this.type == "C") {
            if (index == 2 || index == 0) {
                if (column.sortOrder === 1) {
                    this.data.sort(function (name1, name2) {
                        if (name1.name < name2.name) {
                            return -1;
                        } else if (name1.name > name2.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
                if (column.sortOrder === 2) {
                    this.data.sort(function (name1, name2) {
                        if (name1.name > name2.name) {
                            return -1;
                        } else if (name1.name < name2.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
            }
            if (index == 1) {
                if (column.sortOrder === 1) {
                    this.data.sort(function (name1, name2) {
                        if (name1.artist.name < name2.artist.name) {
                            return -1;
                        } else if (name1.artist.name > name2.artist.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
                if (column.sortOrder === 2) {
                    this.data.sort(function (name1, name2) {
                        if (name1.artist.name > name2.artist.name) {
                            return -1;
                        } else if (name1.artist.name < name2.artist.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
            }
            if(index == 3) {
                if (this.type2 == "Search") {
                    if (column.sortOrder === 1) {
                        this.data.sort(function (name1, name2) {
                            if (name1.genres) {
                                if (name2.genres) {
                                    if (name1.genres.name && name2.genres.name) {
                                        if (name1.genres.name < name2.genres.name) {
                                            return -1;
                                        } else if (name1.genres.name > name2.genres.name) {
                                            return 1;
                                        } else {
                                            return 0;
                                        }
                                    }
                                }
                            }
                        });
                    }
                    if (column.sortOrder === 2) {
                        this.data.sort(function (name1, name2) {
                            if (name1.genres) {
                                if (name2.genres) {
                                    if (name1.genres.name && name2.genres.name) {
                                        if (name1.genres.name > name2.genres.name) {
                                            return -1;
                                        } else if (name1.genres.name < name2.genres.name) {
                                            return 1;
                                        } else {
                                            return 0;
                                        }
                                    }
                                }
                            }
                        });
                    }

                } else {
                    if(column.sortOrder === 1) {
                        this.data.sort(function (name1, name2) {
                            if (name1.genres[0].name && name2.genres[0].name) {
                                if (name1.genres[0].name < name2.genres[0].name) {
                                    return -1;
                                } else if (name1.genres[0].name > name2.genres[0].name) {
                                    return 1;
                                } else {
                                    return 0;
                                }
                            }
                        });
                    }
                    if (column.sortOrder === 2) {
                        this.data.sort(function (name1, name2) {
                            if (name1.genres[0].name && name2.genres[0].name) {
                                if (name1.genres[0].name > name2.genres[0].name) {
                                    return -1;
                                } else if (name1.genres[0].name < name2.genres[0].name) {
                                    return 1;
                                } else {
                                    return 0;
                                }
                            }
                        });
                    }
                }
            }
        }
        if (this.type == "R" || this.type == "OP" || this.type == "P") {
            if (index == 1 || index == 0) {
                if (column.sortOrder === 1) {
                    this.data.sort(function (name1, name2) {
                        if (name1.name < name2.name) {
                            return -1;
                        } else if (name1.name > name2.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
                if (column.sortOrder === 2) {
                    this.data.sort(function (name1, name2) {
                        if (name1.name > name2.name) {
                            return -1;
                        } else if (name1.name < name2.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
            }
            if (index == 2) {
                if (column.sortOrder === 1) {
                    this.data.sort(function (name1, name2) {
                        if (name1.description < name2.description) {
                            return -1;
                        } else if (name1.description > name2.description) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
                if (column.sortOrder === 2) {
                    this.data.sort(function (name1, name2) {
                        if (name1.description > name2.description) {
                            return -1;
                        } else if (name1.description < name2.description) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
            }
            if (index == 3) {
                if (column.sortOrder === 1) {
                    this.data.sort(function (name1, name2) {
                        if (name1.created_by < name2.created_by) {
                            return -1;
                        } else if (name1.created_by > name2.created_by) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
                if (column.sortOrder === 2) {
                    this.data.sort(function (name1, name2) {
                        if (name1.created_by > name2.created_by) {
                            return -1;
                        } else if (name1.created_by < name2.created_by) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
            }
        }
    }

    deleteFromLibrary(event) {
        _.remove(this.data, (arrayItem) => {
            return arrayItem.item.id === event.removed;
        });
    }

    deleteItem(event) {
        _.remove(this.data, (arrayItem) => {
            return arrayItem.id === event.id;
        });
    }

    refreshPlaylist() {
        this.refresh.emit();
    }

}

class Column {
    public title:string = '';
    public key:string = '';
    public type:string = '';
    public width:number = 10;
    public isSortable:boolean = true;
    public textStyle:any = {};
    public sortOrder:SORTORDER = SORTORDER.UNSORTED;
    public responsiveIndex:string = '';
    public fixValue:string = '';
}

enum SORTORDER {
    UNSORTED = 0,
    SORT_ASC = 1,
    SORT_DESC = 2
}



// WEBPACK FOOTER //
// ./src/app/shared/data-table/data-table.component.ts